var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconText = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3H4C3.4 3 3 3.4 3 4V7C3 7.6 3.4 8 4 8C4.6 8 5 7.6 5 7V5H11V19H9C8.4 19 8 19.4 8 20C8 20.6 8.4 21 9 21H15C15.6 21 16 20.6 16 20C16 19.4 15.6 19 15 19H13V5H19V7C19 7.6 19.4 8 20 8C20.6 8 21 7.6 21 7V4C21 3.4 20.6 3 20 3Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconText.369e6cacf7b5292dbf2a2122b0d03216.svg";